<!-- 
  @desc 人才培养基地管理
-->
<template>
  <el-container class="main_panel" direction="vertical">
    <el-col :span="24"> <title-bar :titleBar="'人才培养基地管理'"></title-bar></el-col>
    <el-container direction="vertical" class="content_panel">
      <el-row :gutter="16" class="search_panel">
        <el-col :span="4">
          <el-input placeholder="人才培养基地" size="small"></el-input>
        </el-col>
        <el-col :span="20" align="right">
          <el-button type="primary" size="small" icon="el-icon-search">查询</el-button>
        </el-col>
      </el-row>
      <el-row class="filter_opt">
        <el-col :span="24">
          <el-button type="warning" size="small" icon="el-icon-plus">新建</el-button>
        </el-col>
      </el-row>
      <el-table :data="tableData" class="table" height="500" stripe border size="small">
        <el-table-column label="人才培养基地" align="left"></el-table-column>
        <el-table-column label="操作" fixed="right" width="250" align="left"></el-table-column>
      </el-table>
      <Page />
    </el-container>
  </el-container>
</template>
<script>
import TitleBar from "@/components/public/TitleBar.vue";
import Page from "@/components/public/Page.vue";
export default {
  components: {
    TitleBar,
    Page
  },
  data() {
    return {
      /**表格数据 */
      tableData: []
    };
  }
};
</script>
